import React, { Component } from "react";
import { Api } from "../utils/api";
import { withRouter } from "react-router";
import NewCreditNote from "./components/new_credit_note.component";
import AlertDialog from "../components/alert.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Invoicexpress } from "../utils/invoicexpress";

class CreditNotesNew extends Component {
  state = {
    showAlert: false,
    showLoading: false,
    alertTitle: "",
    alertMessage: "",
    handleClose: this.closeAlert,
    requestInfo: {},
    invoice: {},
    entity: {},
    easypay_payment_id: null,
  };

  constructor() {
    super();
    this.form = null;
    this.api = new Api();
    this.iexpress = new Invoicexpress();
    this.setForm = this.setForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getEntityData = this.getEntityData.bind(this);
    this.getEntityContacts = this.getEntityContacts.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
  }

  /**
   *
   */

  componentDidMount() {
    const invoiceId = this.props.location.state.invoice;
    //
    return this.iexpress.getInvoiceData(invoiceId).then((data) => {
      this.setState({ invoice: data.invoice });
      var clientId = data.invoice.client.id;
      return this.iexpress.getInvoiceClient(clientId).then((data) => {
        return this.getEntityData(clientId).then(() => {
          return this.getRequestInfo(invoiceId);
        });
      });
    });
  }

  /**
   *
   */

  getEntityData(invoicexpress_client_id) {
    return this.api
      .get("/entities", { invoicexpress_client_id })
      .then(({ data = null }) => {
        var entity = data.entities[0];
        return this.getEntityContacts(entity.id).then(({ data = null }) => {
          entity.emails = data.emails;
          this.setState({ entity });
        });
      });
  }

  getEntityContacts(entity_id) {
    return this.api.get("/user_entities", {
      entity_id: entity_id,
      billing_contacts: true,
    });
  }

  getRequestInfo(invoiceId) {
    //
    this.api
      .get("/easypay_payment_invoices", { invoice_id: invoiceId })
      .then(({ data = null }) => {
        //
        if (data.count === 0) return;
        this.setState({
          easypay_payment_id:
            data.easypay_payment_invoices[0].easypay_payment_id,
        });
        this.api
          .get(
            `easypay_payments/${data.easypay_payment_invoices[0].easypay_payment_id}`
          )
          .then(({ data = null }) => {
            //
            if (!data.establishments_request_id) return;

            this.api
              .get(`establishment_requests/${data.establishments_request_id}`)
              .then(({ data = null }) => {
                let requestInfo = this.state.requestInfo;
                requestInfo.monthly_payment = data.monthly_payment;
                requestInfo.request_admitted = data.request_admitted;
                requestInfo.establishment_name =
                  data.establishment_valence.establishment.name;
                this.setState({ requestInfo });
                //
                this.api
                  .get(`user_requests/${data.user_request_id}`)
                  .then(({ data = null }) => {
                    let requestInfo = this.state.requestInfo;
                    requestInfo.elderly_name = data.elderly_name;
                    this.setState({ requestInfo });
                    //
                    if (data.user_id) {
                      this.api
                        .get(`users/${data.user_id}`)
                        .then(({ data = null }) => {
                          let requestInfo = this.state.requestInfo;
                          requestInfo.requester_name = data.name;
                          this.setState({ requestInfo });
                        });
                    }
                  });
              });
          });
      });
  }

  handleSubmit(values, actions) {
    this.renderProgress();
    const taxValue = 0.23;
    const invoice = this.props.location.state.invoice;
    const dailyPrice = values.invoice_value / values.warranty / (taxValue + 1);
    const elderly_name = this.state.requestInfo.elderly_name;
    return this.api
      .post("/invoicexpress_credit_notes", {
        ...values,
        invoice_id: invoice,
        invoice_type: values.invoice_type,
        invoice_status: values.invoice_status,
        daily_price: dailyPrice,
        easypay_payment_id: this.state.easypay_payment_id,
        elderly_name,
      })
      .then((res) => {
        if (res.status === 201) {
          this.showAlert("Sucesso", "Alterações guardadas com sucesso!", () =>
            this.props.history.goBack()
          );
        } else
          this.showAlert("Erro", "Ocorreu um erro a gravar as alterações!");
        actions.setSubmitting(false);
        this.renderProgress();
      })
      .catch((res) => {
        console.log(res);
        this.showAlert("Erro", "Ocorreu um erro a gravar as alterações!");
        actions.setSubmitting(false);
        this.renderProgress();
      });
  }

  /**
   *
   */

  showAlert(title, message, handleClose) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
    this.setState({ handleClose: handleClose ? handleClose : this.closeAlert });
  }

  closeAlert = () => {
    this.setState({ showAlert: false });
  };

  setForm(form) {
    this.form = form;
  }

  /**
   *
   */

  renderProgress() {
    if (this.state.showLoading) this.setState({ showLoading: false });
    else this.setState({ showLoading: true });
  }

  render() {
    const invoice = this.state.invoice;

    return (
      <>
        <div className="main-reqlist-container">
          <NewCreditNote
            getForm={this.setForm}
            onSubmit={this.handleSubmit}
            entity={this.state.entity}
            request={this.state.requestInfo}
            {...invoice}
          />
        </div>
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.state.handleClose}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>

        <div
          hidden={!this.state.showLoading}
          className="credit-notes-loading-div"
        >
          <CircularProgress color="primary" />
        </div>
      </>
    );
  }
}

export default withRouter(CreditNotesNew);
